export default function () {
  this.doLoadItem()
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/next-patient/resources/mounted.js